import React from "react";
import { Navbar } from "@/components/Navbar";
import { RhythmClap } from "@/components/RhythmClap";
import { RhythmLeaderboard } from "@/components/RhythmLeaderboard";

export default function RhythmClapPage() {
  return (
    <div className="min-h-screen text-foreground">
      <Navbar />
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-8 lg:py-16" data-testid="rhythm-clap-page">
        <p className="font-mono text-xs uppercase tracking-widest text-primary">Training</p>
        <h1 className="mt-2 font-serif text-4xl tracking-tight sm:text-5xl">Rhythm Clap</h1>
        <p className="mt-4 text-base text-muted-foreground md:text-lg">Listen to the rhythm, wait for the 4-click count-in, then clap and tap on every note. Your timing is scored note by note — work up from crotchets to quavers and beat your best score.</p>
        <RhythmClap testId="rhythm-clap-standalone" />
        <RhythmLeaderboard testId="rhythm-leaderboard-page" />
      </main>
    </div>
  );
}
